import axios from "axios";
import { CapacitorHttp } from "@capacitor/core";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const API = API_BASE;
export const WS_URL = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");

const axiosInstance = axios.create({ baseURL: API_BASE });
axiosInstance.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

async function nativeFetch(method, path, body) {
  const token = localStorage.getItem("hg_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const options = {
    url: API_BASE + path,
    method,
    headers,
  };
  if (body !== undefined && method !== "GET") options.data = body;
  const resp = await CapacitorHttp.request(options);
  if (resp.status >= 400) {
    const err = new Error(resp.data?.message || `API error ${resp.status}`);
    err.status = resp.status;
    throw err;
  }
  return { data: resp.data, status: resp.status };
}

function isNative() {
  return !!(window.Capacitor?.isNativePlatform?.());
}

function wrap(promise) {
  return promise.then(r => ({ data: r.data, status: r.status, headers: r.headers }));
}

export const api = {
  get: (path) => isNative() ? nativeFetch("GET", path) : wrap(axiosInstance.get(path)),
  post: (path, body) => isNative() ? nativeFetch("POST", path, body) : wrap(axiosInstance.post(path, body)),
  put: (path, body) => isNative() ? nativeFetch("PUT", path, body) : wrap(axiosInstance.put(path, body)),
  delete: (path) => isNative() ? nativeFetch("DELETE", path) : wrap(axiosInstance.delete(path)),
};